<!-- Página de Gerenciamento de Perguntas de Intercorrência (ROOT only) -->
<div class="min-h-screen bg-gray-50">
    <!-- header removed: page uses global v2 header/breadcrumb/title -->

    <!-- Loading -->
    <div *ngIf="loading" class="flex justify-center items-center py-20">
        <app-loading></app-loading>
    </div>

    <!-- Conteúdo Principal -->
    <div *ngIf="!loading" class="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <!-- Resumo + Botão Publicar -->
        <div class="bg-white rounded-lg border p-4 mb-6 flex flex-wrap items-center gap-4 text-sm text-gray-600">
            <div>
                <span class="font-medium text-gray-900">{{ sections.length }}</span> seções
            </div>
            <div class="w-px h-4 bg-gray-300"></div>
            <div>
                <span class="font-medium text-gray-900">{{ getTotalQuestions() }}</span> perguntas no total
            </div>
            <div *ngIf="currentVersion > 0" class="w-px h-4 bg-gray-300"></div>
            <div *ngIf="currentVersion > 0">
                Versão publicada: <span class="font-medium text-gray-900">v{{ currentVersion }}</span>
            </div>

            <!-- Botão Publicar (alinhado à direita) -->
            <div class="ml-auto">
                <button (click)="requestPublish()"
                        [disabled]="publishLoading || loading"
                        class="bg-westetics-purple-800 hover:bg-westetics-purple-700 disabled:bg-gray-400 text-white px-4 sm:px-6 py-2 rounded-lg font-medium transition-colors flex items-center gap-2 text-sm">
                    <fa-icon *ngIf="!publishLoading" [icon]="faSave"></fa-icon>
                    <span *ngIf="publishLoading" class="animate-spin">⟳</span>
                    Publicar Alterações
                </button>
            </div>
        </div>

        <!-- Seções -->
        <div *ngFor="let section of sections; let sectionIndex = index" class="mb-6">
            <!-- Header da Seção -->
            <div class="bg-white rounded-t-lg border border-b-0 px-4 sm:px-5 py-3 cursor-pointer hover:bg-gray-50 transition-colors"
                 (click)="toggleSection(section.id || 'section_' + sectionIndex)">
                <div class="flex justify-between items-center">
                    <div class="flex items-center gap-3">
                        <fa-icon [icon]="expandedSections[section.id || 'section_' + sectionIndex] ? faChevronUp : faChevronDown"
                                 class="text-gray-400 text-sm"></fa-icon>
                        <div>
                            <h3 class="font-semibold text-base sm:text-lg text-gray-900">{{ section.section_title }}</h3>
                            <p class="text-xs sm:text-sm text-gray-500">{{ section.questions.length }} pergunta(s)</p>
                        </div>
                    </div>
                    <button (click)="addQuestion(sectionIndex); $event.stopPropagation()"
                            class="text-westetics-purple-800 hover:text-westetics-purple-900 hover:bg-westetics-purple-50 px-3 py-1.5 rounded-md transition-colors text-sm font-medium flex items-center gap-1">
                        <fa-icon [icon]="faPlus" size="sm"></fa-icon>
                        <span class="hidden sm:inline">Adicionar Pergunta</span>
                    </button>
                </div>
            </div>

            <!-- Perguntas da Seção -->
            <div *ngIf="expandedSections[section.id || 'section_' + sectionIndex]"
                 class="bg-white rounded-b-lg border">

                <!-- Sem perguntas -->
                <div *ngIf="section.questions.length === 0" class="px-5 py-8 text-center text-gray-400 text-sm">
                    Nenhuma pergunta nesta seção. Clique em "Adicionar Pergunta" para começar.
                </div>

                <!-- Lista de Perguntas -->
                <div *ngFor="let question of section.questions; let questionIndex = index"
                     class="border-t first:border-t-0 px-4 sm:px-5 py-4"
                     [class.bg-westetics-purple-50]="editingQuestionId === question.id">

                    <!-- ═══════ Modo Visualização ═══════ -->
                    <div *ngIf="editingQuestionId !== question.id" class="flex items-start gap-3">
                        <!-- Grip + ordem -->
                        <div class="flex flex-col items-center gap-1 text-gray-300 pt-1">
                            <span class="text-xs font-bold text-gray-400">{{ question.order_in_section }}</span>
                        </div>

                        <!-- Conteúdo -->
                        <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-2 flex-wrap">
                                <span class="font-medium text-gray-900 text-sm sm:text-base">{{ question.question_text }}</span>
                                <span *ngIf="question.is_required" class="text-red-500 text-xs font-medium">(Obrigatória)</span>
                            </div>
                            <div class="flex items-center gap-2 mt-1 flex-wrap">
                                <span class="bg-westetics-purple-50 text-westetics-purple-800 px-2 py-0.5 rounded text-xs font-medium">
                                    {{ getTypeLabel(question.type) }}
                                </span>
                                <span *ngIf="question.placeholder" class="text-gray-400 text-xs italic truncate max-w-[200px]">
                                    Placeholder: {{ question.placeholder }}
                                </span>
                            </div>

                            <!-- Opções (para SINGLE_CHOICE e MULTIPLE_CHOICE) -->
                            <div *ngIf="question.options && question.options.length > 0" class="mt-2 space-y-1">
                                <div *ngFor="let opt of question.options" class="text-xs sm:text-sm text-gray-600">
                                    <div class="flex items-center gap-2">
                                        <span class="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0"></span>
                                        <span>{{ opt.option_text }}</span>
                                        <span *ngIf="opt.triggers_free_text" class="text-westetics-purple-600 text-xs">(abre campo livre)</span>
                                    </div>
                                    <!-- Sub-perguntas da opção (modo visualização) -->
                                    <div *ngIf="opt.sub_questions && opt.sub_questions.length > 0" class="ml-6 mt-1 space-y-1 border-l-2 border-purple-200 pl-3">
                                        <div *ngFor="let subQ of opt.sub_questions" class="text-xs text-gray-500">
                                            <div class="flex items-center gap-1">
                                                <span class="text-purple-500 font-medium">↳</span>
                                                <span class="font-medium text-gray-700">{{ subQ.question_text }}</span>
                                                <span class="bg-westetics-purple-50 text-westetics-purple-800 px-1.5 py-0 rounded text-[10px]">{{ getTypeLabel(subQ.type) }}</span>
                                            </div>
                                            <div *ngIf="subQ.options && subQ.options.length > 0" class="ml-4 mt-0.5">
                                                <span *ngFor="let sqOpt of subQ.options; let last = last" class="text-gray-400">
                                                    {{ sqOpt.option_text }}<span *ngIf="!last">, </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Campos de Objeto (para tipo OBJECT) -->
                            <div *ngIf="question.object_fields && question.object_fields.length > 0" class="mt-2">
                                <div class="text-xs text-gray-500 font-medium mb-1">Campos do objeto:</div>
                                <div class="flex flex-wrap gap-1.5">
                                    <span *ngFor="let field of question.object_fields"
                                          class="inline-flex items-center gap-1 bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded text-xs border border-emerald-200">
                                        <span class="font-medium">{{ field.field_label }}</span>
                                        <span class="text-emerald-500">({{ getFieldTypeLabel(field.field_type) }})</span>
                                        <span *ngIf="field.is_required" class="text-red-400">*</span>
                                        <span *ngIf="field.field_type === 'SELECT' && field.select_options && field.select_options.length > 0"
                                              class="text-emerald-400 text-[10px]">[{{ field.select_options.join(', ') }}]</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Ações -->
                        <div class="flex items-center gap-1 flex-shrink-0">
                            <button *ngIf="questionIndex > 0"
                                    (click)="moveQuestion(sectionIndex, questionIndex, 'up')"
                                    class="p-1.5 hover:bg-gray-100 rounded text-gray-400 hover:text-gray-600 transition-colors"
                                    title="Mover para cima">
                                <fa-icon [icon]="faChevronUp" size="sm"></fa-icon>
                            </button>
                            <button *ngIf="questionIndex < section.questions.length - 1"
                                    (click)="moveQuestion(sectionIndex, questionIndex, 'down')"
                                    class="p-1.5 hover:bg-gray-100 rounded text-gray-400 hover:text-gray-600 transition-colors"
                                    title="Mover para baixo">
                                <fa-icon [icon]="faChevronDown" size="sm"></fa-icon>
                            </button>
                            <button (click)="startEditing(question)"
                                    class="p-1.5 hover:bg-westetics-purple-100 rounded text-westetics-purple-800 transition-colors"
                                    title="Editar">
                                <fa-icon [icon]="faEdit" size="sm"></fa-icon>
                            </button>
                            <button (click)="confirmDeleteQuestion(sectionIndex, questionIndex)"
                                    class="p-1.5 hover:bg-westetics-purple-100 rounded text-westetics-purple-800 transition-colors"
                                    title="Excluir">
                                <fa-icon [icon]="faTrash" size="sm"></fa-icon>
                            </button>
                        </div>
                    </div>

                    <!-- ═══════ Modo Edição ═══════ -->
                    <div *ngIf="editingQuestionId === question.id && editForm" class="space-y-4">
                        <form [formGroup]="editForm">
                            <!-- Linha 1: Texto + Tipo -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                <div class="md:col-span-2">
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Texto da pergunta *</label>
                                    <input type="text"
                                           formControlName="question_text"
                                           class="w-full p-2 border rounded-md focus:ring-2 focus:ring-westetics-purple-500 focus:border-westetics-purple-500 text-sm"
                                           [class.border-red-500]="editForm.get('question_text')?.invalid && editForm.get('question_text')?.touched"
                                           placeholder="Ex: Houve alguma intercorrência durante o procedimento?">
                                    <span *ngIf="editForm.get('question_text')?.invalid && editForm.get('question_text')?.touched"
                                          class="text-red-500 text-xs mt-1">Campo obrigatório</span>
                                </div>
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Tipo *</label>
                                    <select formControlName="type"
                                            class="w-full p-2 border rounded-md focus:ring-2 focus:ring-westetics-purple-500 focus:border-westetics-purple-500 text-sm">
                                        <option *ngFor="let t of questionTypes" [value]="t.value">{{ t.label }}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Linha 2: Placeholder + Obrigatória -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                <div class="md:col-span-2">
                                    <label class="block text-sm font-medium text-gray-700 mb-1">Placeholder / Texto de ajuda</label>
                                    <input type="text"
                                           formControlName="placeholder"
                                           class="w-full p-2 border rounded-md focus:ring-2 focus:ring-westetics-purple-500 focus:border-westetics-purple-500 text-sm"
                                           placeholder="Texto exibido quando o campo está vazio">
                                </div>
                                <div class="flex items-end pb-1">
                                    <label class="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" formControlName="is_required"
                                               class="w-4 h-4 text-westetics-purple-600 border-gray-300 rounded focus:ring-westetics-purple-500">
                                        <span class="text-sm text-gray-700">Obrigatória</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Opções (se SINGLE_CHOICE ou MULTIPLE_CHOICE) -->
                            <div *ngIf="needsOptions(editForm.get('type')?.value)" class="mb-4">
                                <label class="block text-sm font-medium text-gray-700 mb-2">Opções</label>
                                <div formArrayName="options" class="space-y-3">
                                    <div *ngFor="let optCtrl of editOptionsArray.controls; let optIndex = index"
                                         [formGroupName]="optIndex"
                                         class="border border-gray-200 rounded-lg p-3 bg-gray-50">
                                        <!-- Linha da opção -->
                                        <div class="flex items-center gap-2">
                                            <span class="text-xs text-gray-400 w-5 text-right">{{ optIndex + 1 }}.</span>
                                            <input type="text"
                                                   formControlName="option_text"
                                                   class="flex-1 p-2 border rounded-md focus:ring-2 focus:ring-westetics-purple-500 focus:border-westetics-purple-500 text-sm"
                                                   [class.border-red-500]="optCtrl.get('option_text')?.invalid && optCtrl.get('option_text')?.touched"
                                                   placeholder="Texto da opção">
                                            <label class="flex items-center gap-1 text-xs text-gray-600 whitespace-nowrap cursor-pointer">
                                                <input type="checkbox" formControlName="triggers_free_text"
                                                       class="w-3.5 h-3.5 text-westetics-purple-600 border-gray-300 rounded">
                                                <span class="hidden sm:inline">Abre campo livre</span>
                                                <span class="sm:hidden">Obs.</span>
                                            </label>
                                            <button type="button" (click)="removeOption(optIndex)"
                                                    class="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                                                    title="Remover opção">
                                                <fa-icon [icon]="faTimes" size="sm"></fa-icon>
                                            </button>
                                        </div>

                                        <!-- Sub-perguntas desta opção -->
                                        <div class="mt-2 ml-7 border-l-2 border-purple-300 pl-3">
                                            <div formArrayName="sub_questions" class="space-y-2">
                                                <div *ngFor="let sqCtrl of getSubQuestionsArray(optIndex).controls; let sqIndex = index"
                                                     [formGroupName]="sqIndex"
                                                     class="bg-white border border-purple-200 rounded-md p-2 space-y-2">
                                                    <!-- Texto + Tipo da sub-pergunta -->
                                                    <div class="flex items-center gap-2">
                                                        <span class="text-purple-500 text-xs font-medium">↳</span>
                                                        <input type="text"
                                                               formControlName="question_text"
                                                               class="flex-1 p-1.5 border rounded-md text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
                                                               [class.border-red-500]="sqCtrl.get('question_text')?.invalid && sqCtrl.get('question_text')?.touched"
                                                               placeholder="Texto da sub-pergunta">
                                                        <select formControlName="type"
                                                                class="p-1.5 border rounded-md text-xs focus:ring-2 focus:ring-purple-400">
                                                            <option *ngFor="let t of questionTypes" [value]="t.value">{{ t.label }}</option>
                                                        </select>
                                                        <label class="flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap cursor-pointer">
                                                            <input type="checkbox" formControlName="is_required"
                                                                   class="w-3 h-3 text-purple-600 border-gray-300 rounded">
                                                            <span>Obrig.</span>
                                                        </label>
                                                        <button type="button" (click)="removeSubQuestion(optIndex, sqIndex)"
                                                                class="p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                                                                title="Remover sub-pergunta">
                                                            <fa-icon [icon]="faTimes" size="xs"></fa-icon>
                                                        </button>
                                                    </div>

                                                    <!-- Opções da sub-pergunta (se necessário) -->
                                                    <div *ngIf="needsOptions(sqCtrl.get('type')?.value)" class="ml-5">
                                                        <div formArrayName="options" class="space-y-1">
                                                            <div *ngFor="let sqOptCtrl of getSubQuestionOptionsArray(optIndex, sqIndex).controls; let sqOptIdx = index"
                                                                 [formGroupName]="sqOptIdx"
                                                                 class="flex items-center gap-1.5">
                                                                <span class="text-[10px] text-gray-400 w-4 text-right">{{ sqOptIdx + 1 }}.</span>
                                                                <input type="text"
                                                                       formControlName="option_text"
                                                                       class="flex-1 p-1 border rounded text-xs focus:ring-1 focus:ring-purple-400"
                                                                       [class.border-red-500]="sqOptCtrl.get('option_text')?.invalid && sqOptCtrl.get('option_text')?.touched"
                                                                       placeholder="Opção">
                                                                <button type="button" (click)="removeSubQuestionOption(optIndex, sqIndex, sqOptIdx)"
                                                                        class="p-0.5 text-red-400 hover:text-red-600 rounded"
                                                                        title="Remover">
                                                                    <fa-icon [icon]="faTimes" size="xs"></fa-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <button type="button" (click)="addSubQuestionOption(optIndex, sqIndex)"
                                                                class="mt-1 text-purple-600 hover:text-purple-800 text-xs font-medium flex items-center gap-1">
                                                            <fa-icon [icon]="faPlus" size="xs"></fa-icon>
                                                            Opção
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" (click)="addSubQuestion(optIndex)"
                                                    class="mt-1.5 text-purple-600 hover:text-purple-800 text-xs font-medium flex items-center gap-1">
                                                <fa-icon [icon]="faPlus" size="xs"></fa-icon>
                                                Sub-pergunta
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" (click)="addOption()"
                                        class="mt-2 text-westetics-purple-600 hover:text-westetics-purple-800 text-sm font-medium flex items-center gap-1">
                                    <fa-icon [icon]="faPlus" size="sm"></fa-icon>
                                    Adicionar opção
                                </button>
                            </div>

                            <!-- Campos de Objeto (se tipo OBJECT) -->
                            <div *ngIf="isObjectType(editForm.get('type')?.value)" class="mb-4">
                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                    Campos do Objeto
                                    <span class="text-xs text-gray-400 font-normal ml-1">(defina a estrutura que o usuário vai preencher)</span>
                                </label>
                                <div formArrayName="object_fields" class="space-y-3">
                                    <div *ngFor="let fieldCtrl of editObjectFieldsArray.controls; let fieldIndex = index"
                                         [formGroupName]="fieldIndex"
                                         class="border border-emerald-200 rounded-lg p-3 bg-emerald-50">
                                        <!-- Linha 1: Label + Tipo + Remover -->
                                        <div class="flex flex-wrap items-end gap-3">
                                            <div class="flex-1 min-w-[180px]">
                                                <label class="block text-xs text-gray-500 mb-0.5">Nome do campo *</label>
                                                <input type="text"
                                                       formControlName="field_label"
                                                       class="w-full p-1.5 border rounded-md text-sm focus:ring-2 focus:ring-emerald-400 focus:border-emerald-400"
                                                       [class.border-red-500]="fieldCtrl.get('field_label')?.invalid && fieldCtrl.get('field_label')?.touched"
                                                       placeholder="Ex: Dose">
                                            </div>
                                            <div class="w-44">
                                                <label class="block text-xs text-gray-500 mb-0.5">Tipo</label>
                                                <select formControlName="field_type"
                                                        class="w-full p-1.5 border rounded-md text-sm focus:ring-2 focus:ring-emerald-400">
                                                    <option *ngFor="let ft of objectFieldTypes" [value]="ft.value">{{ ft.label }}</option>
                                                </select>
                                            </div>
                                            <div class="pb-0.5">
                                                <button type="button" (click)="removeObjectField(fieldIndex)"
                                                        class="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                                                        title="Remover campo">
                                                    <fa-icon [icon]="faTimes" size="sm"></fa-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- Linha 2: Placeholder + Obrigatório -->
                                        <div class="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2">
                                            <div class="md:col-span-2">
                                                <label class="block text-xs text-gray-500 mb-0.5">Placeholder</label>
                                                <input type="text"
                                                       formControlName="placeholder"
                                                       class="w-full p-1.5 border rounded-md text-sm focus:ring-2 focus:ring-emerald-400"
                                                       placeholder="Texto de ajuda">
                                            </div>
                                            <div class="flex items-center">
                                                <label class="flex items-center mt-4 gap-2 text-xs text-gray-600 cursor-pointer">
                                                    <input type="checkbox" formControlName="is_required"
                                                           class="w-4 h-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500">
                                                    <span>Obrigatório</span>
                                                </label>
                                            </div>
                                        </div>
                                        <!-- Linha 3: Opções para SELECT -->
                                        <div *ngIf="fieldCtrl.get('field_type')?.value === 'SELECT'" class="mt-2">
                                            <label class="block text-xs text-gray-500 mb-0.5">Opções (separadas por vírgula)</label>
                                            <input type="text"
                                                   formControlName="select_options_text"
                                                   class="w-full p-1.5 border rounded-md text-sm focus:ring-2 focus:ring-emerald-400"
                                                   placeholder="Ex: Oral, Intravenosa, Intramuscular">
                                        </div>
                                    </div>
                                </div>
                                <button type="button" (click)="addObjectField()"
                                        class="mt-2 text-emerald-600 hover:text-emerald-800 text-sm font-medium flex items-center gap-1">
                                    <fa-icon [icon]="faPlus" size="sm"></fa-icon>
                                    Adicionar campo
                                </button>
                            </div>

                            <!-- Ações do formulário -->
                            <div class="flex items-center gap-2 pt-2 border-t border-gray-100">
                                <button type="button" (click)="saveQuestion()"
                                        class="bg-westetics-purple-800 hover:bg-westetics-purple-700 text-white px-4 py-1.5 rounded-md text-sm font-medium transition-colors flex items-center gap-1">
                                    <fa-icon [icon]="faCheck" size="sm"></fa-icon>
                                    Salvar
                                </button>
                                <button type="button" (click)="cancelEditing()"
                                        class="text-gray-600 hover:text-gray-800 hover:bg-gray-100 px-4 py-1.5 rounded-md text-sm font-medium transition-colors">
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════
     MODAL: Confirmação de Publicação
     ═══════════════════════════════════════════════════════════════════ -->
<div *ngIf="showPublishConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
    <div class="bg-white rounded-lg w-full max-w-md p-6 shadow-xl">
        <div class="flex items-start gap-3 mb-4">
            <div class="bg-yellow-100 rounded-full p-2 flex-shrink-0">
                <fa-icon [icon]="faExclamationTriangle" class="text-yellow-600"></fa-icon>
            </div>
            <div>
                <h3 class="font-bold text-lg text-gray-900">Publicar alterações?</h3>
                <p class="text-sm text-gray-600 mt-1">
                    As perguntas serão atualizadas para <strong>todas as clínicas</strong>.
                    Registros existentes não serão alterados, mas novos formulários utilizarão as perguntas atualizadas.
                </p>
            </div>
        </div>
        <div class="flex justify-end gap-2 mt-6">
            <button (click)="showPublishConfirmation = false"
                    class="px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md text-sm font-medium transition-colors">
                Cancelar
            </button>
            <button (click)="publish()"
                    class="bg-westetics-purple-800 hover:bg-westetics-purple-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">
                Confirmar Publicação
            </button>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════
     MODAL: Confirmação de Exclusão
     ═══════════════════════════════════════════════════════════════════ -->
<div *ngIf="showDeleteConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
    <div class="bg-white rounded-lg w-full max-w-md p-6 shadow-xl">
        <div class="flex items-start gap-3 mb-4">
            <div class="bg-red-100 rounded-full p-2 flex-shrink-0">
                <fa-icon [icon]="faExclamationTriangle" class="text-red-600"></fa-icon>
            </div>
            <div>
                <h3 class="font-bold text-lg text-gray-900">Excluir pergunta?</h3>
                <p class="text-sm text-gray-600 mt-1">
                    Esta ação não pode ser desfeita. A pergunta será removida do formulário após a publicação.
                </p>
            </div>
        </div>
        <div class="flex justify-end gap-2 mt-6">
            <button (click)="showDeleteConfirmation = false; questionToDelete = null"
                    class="px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md text-sm font-medium transition-colors">
                Cancelar
            </button>
            <button (click)="deleteQuestion()"
                    class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">
                Excluir
            </button>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════
     MODAL: Alterações não salvas
     ═══════════════════════════════════════════════════════════════════ -->
<div *ngIf="showUnsavedChangesModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
    <div class="bg-white rounded-lg w-full max-w-lg p-6 shadow-xl">
        <div class="flex items-start gap-3 mb-4">
            <div class="bg-yellow-100 rounded-full p-2 flex-shrink-0">
                <fa-icon [icon]="faExclamationTriangle" class="text-yellow-600"></fa-icon>
            </div>
            <div>
                <h3 class="font-bold text-lg text-gray-900">Alterações não publicadas</h3>
                <p class="text-sm text-gray-600 mt-1">
                    Você possui perguntas adicionadas que ainda não foram publicadas. Se sair agora, as alterações serão perdidas.
                </p>
            </div>
        </div>
        <div class="flex justify-end gap-2 mt-6">
            <button (click)="confirmLeave()"
                    class="px-4 py-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 border border-gray-300 rounded-md text-sm font-medium transition-colors">
                Sair
            </button>
            <button (click)="publishAndLeave()"
                    [disabled]="publishLoading"
                    class="bg-westetics-purple-800 hover:bg-westetics-purple-700 disabled:bg-gray-400 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2">
                <fa-icon *ngIf="!publishLoading" [icon]="faSave"></fa-icon>
                <span *ngIf="publishLoading" class="animate-spin">⟳</span>
                Publicar
            </button>
        </div>
    </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════
     MODAL: Erros de Validação
     ═══════════════════════════════════════════════════════════════════ -->
<div *ngIf="showValidationErrors" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
    <div class="bg-white rounded-lg w-full max-w-md p-6 shadow-xl">
        <div class="flex items-start gap-3 mb-4">
            <div class="bg-red-100 rounded-full p-2 flex-shrink-0">
                <fa-icon [icon]="faExclamationTriangle" class="text-red-600"></fa-icon>
            </div>
            <div>
                <h3 class="font-bold text-lg text-gray-900">Erros de validação</h3>
                <p class="text-sm text-gray-600 mt-1">Corrija os seguintes problemas antes de publicar:</p>
            </div>
        </div>
        <ul class="space-y-1 mb-6 max-h-60 overflow-y-auto">
            <li *ngFor="let msg of validationErrorMessages" class="text-sm text-red-600 flex items-start gap-2">
                <span class="mt-0.5 flex-shrink-0">•</span>
                <span>{{ msg }}</span>
            </li>
        </ul>
        <div class="flex justify-end">
            <button (click)="showValidationErrors = false"
                    class="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">
                Entendi
            </button>
        </div>
    </div>
</div>
